<mat-form-field appearance="outline">
	<mat-label>{{ placeholder }}</mat-label>
	<mat-select
		[required]="control.isRequired"
		*ngIf="multiple"
		[formControl]="control"
		[errorStateMatcher]="matcher"
		[disabled]="readOnly"
		multiple
	>
		<mat-option *ngFor="let option of options" [value]="option.id"
			><mat-icon *ngIf="option.icon" svgIcon="verifiedUser" class="verifiedUser"></mat-icon
			>{{ option.label }}</mat-option
		>
	</mat-select>
	<mat-select
		[required]="control.isRequired"
		*ngIf="!multiple"
		[formControl]="control"
		[errorStateMatcher]="matcher"
		[disabled]="readOnly"
	>
		<mat-option>--</mat-option>
		<mat-option *ngFor="let option of options" [value]="option.id"
			><mat-icon *ngIf="option.icon == true" svgIcon="verifiedUser" class="verifiedUser"></mat-icon
			>{{ option.label }}</mat-option
		>
	</mat-select>

	<!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
	<ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
		<mat-error *ngIf="control.hasError(key)">
			{{ control.getErrorMessage(key) }}
		</mat-error>
	</ng-template>
</mat-form-field>
